import { PanelsTopLeft } from "lucide-react";
import type { ReactNode } from "react";

import { ThemeToggle } from "@/shell/ThemeToggle";

/**
 * The frame of the pages outside the shell: sign-in, an invite, a forgotten password.
 * The product's name over one card, with a line under it when given.
 */
export function AuthFrame({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  return (
    <main className="relative grid min-h-dvh place-items-center bg-bg px-4 py-10">
      <div className="absolute top-3 right-3">
        <ThemeToggle />
      </div>
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <span
            aria-hidden="true"
            className="grid size-9 place-items-center rounded-md bg-accent text-accent-ink"
          >
            <PanelsTopLeft className="size-5" />
          </span>
          <span className="text-base font-semibold text-ink">Unit Take-Off</span>
        </div>
        <div className="rounded-xl border border-line bg-surface p-6 shadow-sm">{children}</div>
        {footer ? <p className="mt-4 text-center text-xs text-muted">{footer}</p> : null}
      </div>
    </main>
  );
}
